import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription, combineLatestWith, of, mergeMap, tap } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { JSONAtaObject } from 'src/app/features/shared/helper-classes';

/* data storage interface for ngrx */
import { DataStorage } from 'src/app/features/data-stores/data-storage.interface';

import * as lodash from 'lodash';

/* actions */
import { Navigate } from 'src/app/features/data-stores/router-data-store/state/router-data-store.actions';

// prettier-ignore
// #region customCode: page-component-ts__package-import__end

// #endregion customCode: page-component-ts__package-import__end

@Component({
  selector: 'liife-jobs-navbar-footer',
  templateUrl: './jobs-navbar-footer.component.html',
  styleUrls: ['./jobs-navbar-footer.component.scss']
})
export class JobsNavbarFooterComponent implements OnInit, OnDestroy {

  // prettier-ignore
    // #region customCode: page-component-ts__ui-page-component-class__start
  
  // #endregion customCode: page-component-ts__ui-page-component-class__start

  
    /* Component: Button 18 */
    button_18: any = {
      text:"Terms",type:"link",shape:"default",size:"default",colorType:"default",icon:null,iconPlacement:null,transparent:false,loading:false,block:false,disabled:null,key:"",emitWithoutPopconfirm:null,popconfirmTitle:"",borderSettings:{"border":"","borderColor":null,"borderStyle":null,"borderRadius":null,"borderTop":null,"borderRight":null,"borderBottom":null,"borderLeft":null,"borderTopLeftRadius":null,"borderTopRightRadius":null,"borderBottomLeftRadius":null,"borderBottomRightRadius":null},marginSettings:null,paddingSettings:null,shadowSettings:null,customColorSettings:{"color":null,"backgroundColor":null},customSizeSettings:{"width":null,"maxWidth":null,"minWidth":null,"height":null,"maxHeight":null,"minHeight":null},redirectUrl:null,
        redirectTarget:{},
        tooltipText:null,
        };
  
    /* Component: Button 24 */
    button_24: any = {
      text:"Designer",type:"link",shape:"default",size:"default",colorType:"default",icon:null,iconPlacement:null,transparent:false,loading:false,block:false,disabled:null,key:"",emitWithoutPopconfirm:null,popconfirmTitle:"",borderSettings:{"border":"","borderColor":null,"borderStyle":null,"borderRadius":null,"borderTop":null,"borderRight":null,"borderBottom":null,"borderLeft":null,"borderTopLeftRadius":null,"borderTopRightRadius":null,"borderBottomLeftRadius":null,"borderBottomRightRadius":null},marginSettings:null,paddingSettings:null,shadowSettings:null,customColorSettings:{"color":null,"backgroundColor":null},customSizeSettings:{"width":null,"maxWidth":null,"minWidth":null,"height":null,"maxHeight":null,"minHeight":null},redirectUrl:null,
        redirectTarget:{},
        tooltipText:null,
        };
  
    /* Component: Heading 20 */
    heading_20: any = {
      content:"Top Categories",type:"h6",typography:{},
        colorSettings:{},
        };
  
    /* Component: Button 30 */
    button_30: any = {
      text:"+1 (555) 555-5555",type:"link",shape:"default",size:"default",colorType:"default",icon:null,iconPlacement:null,transparent:false,loading:false,block:false,disabled:null,key:"",emitWithoutPopconfirm:null,popconfirmTitle:"",borderSettings:{"border":"","borderColor":null,"borderStyle":null,"borderRadius":null,"borderTop":null,"borderRight":null,"borderBottom":null,"borderLeft":null,"borderTopLeftRadius":null,"borderTopRightRadius":null,"borderBottomLeftRadius":null,"borderBottomRightRadius":null},marginSettings:null,paddingSettings:null,shadowSettings:null,customColorSettings:{"color":null,"backgroundColor":null},customSizeSettings:{"width":null,"maxWidth":null,"minWidth":null,"height":null,"maxHeight":null,"minHeight":null},redirectUrl:null,
        redirectTarget:{},
        tooltipText:null,
        };
  
    /* Component: Button 22 */
    button_22: any = {
      text:"Developers",type:"link",shape:"default",size:"default",colorType:"default",icon:null,iconPlacement:null,transparent:false,loading:false,block:false,disabled:null,key:"",emitWithoutPopconfirm:null,popconfirmTitle:"",borderSettings:{"border":"","borderColor":null,"borderStyle":null,"borderRadius":null,"borderTop":null,"borderRight":null,"borderBottom":null,"borderLeft":null,"borderTopLeftRadius":null,"borderTopRightRadius":null,"borderBottomLeftRadius":null,"borderBottomRightRadius":null},marginSettings:null,paddingSettings:null,shadowSettings:null,customColorSettings:{"color":null,"backgroundColor":null},customSizeSettings:{"width":null,"maxWidth":null,"minWidth":null,"height":null,"maxHeight":null,"minHeight":null},redirectUrl:null,
        redirectTarget:{},
        tooltipText:null,
        };
  
    /* Component: Image 1 */
    image_1: any = {
      source:"/assets/liife-logo-white.png",alternateText:"",placeholder:null,disablePreview:false,borderSettings:null,shadowSettings:null,paddingSettings:null,marginSettings:null,customSizeSettings:{"width":"120px","maxWidth":null,"minWidth":null,"height":null,"maxHeight":null,"minHeight":null},};
  
    /* Component: Button 28 */
    button_28: any = {
      text:"Legal Adviser",type:"link",shape:"default",size:"default",colorType:"default",icon:null,iconPlacement:null,transparent:false,loading:false,block:false,disabled:null,key:"",emitWithoutPopconfirm:null,popconfirmTitle:"",borderSettings:{"border":"","borderColor":null,"borderStyle":null,"borderRadius":null,"borderTop":null,"borderRight":null,"borderBottom":null,"borderLeft":null,"borderTopLeftRadius":null,"borderTopRightRadius":null,"borderBottomLeftRadius":null,"borderBottomRightRadius":null},marginSettings:null,paddingSettings:null,shadowSettings:null,customColorSettings:{"color":null,"backgroundColor":null},customSizeSettings:{"width":null,"maxWidth":null,"minWidth":null,"height":null,"maxHeight":null,"minHeight":null},redirectUrl:null,
        redirectTarget:{},
        tooltipText:null,
        };
  
    /* Component: Heading 32 */
    heading_32: any = {
      content:"Follow us",type:"h5",typography:{},
        colorSettings:{},
        };
  
    /* Component: Button 42 */
    button_42: any = {
      text:"",type:"link",shape:"default",size:"default",colorType:"default",icon:{"name":"fa-regular fa-brands fa-linkedin  ","color":"","size":"25px","type":"FONT_AWESOME","theme":"","secondColor":""},iconPlacement:null,transparent:false,loading:false,block:false,disabled:null,key:"",emitWithoutPopconfirm:null,popconfirmTitle:"",borderSettings:{"border":"","borderColor":null,"borderStyle":null,"borderRadius":null,"borderTop":null,"borderRight":null,"borderBottom":null,"borderLeft":null,"borderTopLeftRadius":null,"borderTopRightRadius":null,"borderBottomLeftRadius":null,"borderBottomRightRadius":null},marginSettings:null,paddingSettings:null,shadowSettings:null,customColorSettings:{"color":null,"backgroundColor":null},customSizeSettings:{"width":null,"maxWidth":null,"minWidth":null,"height":null,"maxHeight":null,"minHeight":null},redirectUrl:"https://www.linkedin.com/company/liife-inc",redirectTarget:"_blank",tooltipText:null,
        };
  
    /* Component: Button 7 */
    button_7: any = {
      text:"SignUp",type:"default",shape:"default",size:"small",colorType:"default",icon:{"name":"fa-solid fa-user-circle","type":"FONT_AWESOME"},iconPlacement:"right",transparent:false,loading:false,block:false,disabled:null,key:"",emitWithoutPopconfirm:null,popconfirmTitle:"",borderSettings:{"border":"","borderColor":"#1f1be5","borderStyle":"solid","borderRadius":null,"borderTop":null,"borderRight":null,"borderBottom":null,"borderLeft":null,"borderTopLeftRadius":"0px","borderTopRightRadius":null,"borderBottomLeftRadius":"0px","borderBottomRightRadius":null},marginSettings:null,paddingSettings:{"all":"0","top":"","right":"","bottom":"","left":""},shadowSettings:null,customColorSettings:{"color":"","backgroundColor":""},customSizeSettings:{"width":"80px","maxWidth":null,"minWidth":null,"height":null,"maxHeight":null,"minHeight":null},redirectUrl:null,
        redirectTarget:{},
        tooltipText:null,
        };
  
    /* Component: Button 19 */
    button_19: any = {
      text:"Privacy",type:"link",shape:"default",size:"default",colorType:"default",icon:null,iconPlacement:null,transparent:false,loading:false,block:false,disabled:null,key:"",emitWithoutPopconfirm:null,popconfirmTitle:"",borderSettings:{"border":"","borderColor":null,"borderStyle":null,"borderRadius":null,"borderTop":null,"borderRight":null,"borderBottom":null,"borderLeft":null,"borderTopLeftRadius":null,"borderTopRightRadius":null,"borderBottomLeftRadius":null,"borderBottomRightRadius":null},marginSettings:null,paddingSettings:null,shadowSettings:null,customColorSettings:{"color":null,"backgroundColor":null},customSizeSettings:{"width":null,"maxWidth":null,"minWidth":null,"height":null,"maxHeight":null,"minHeight":null},redirectUrl:null,
        redirectTarget:{},
        tooltipText:null,
        };
  
    /* Component: Html Viewer 38 */
    htmlViewer_38: any = {
      html:"<p><em>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean tempor convallis pharetra. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Nam aliquet interdum scelerisque. Fusce lobortis nibh convallis risus elementum lacinia. Nulla facilisi. Ut vitae scelerisque augue.</em></p>\n",};
  
    /* Component: Button 26 */
    button_26: any = {
      text:"Data Science",type:"link",shape:"default",size:"default",colorType:"default",icon:null,iconPlacement:null,transparent:false,loading:false,block:false,disabled:null,key:"",emitWithoutPopconfirm:null,popconfirmTitle:"",borderSettings:{"border":"","borderColor":null,"borderStyle":null,"borderRadius":null,"borderTop":null,"borderRight":null,"borderBottom":null,"borderLeft":null,"borderTopLeftRadius":null,"borderTopRightRadius":null,"borderBottomLeftRadius":null,"borderBottomRightRadius":null},marginSettings:null,paddingSettings:null,shadowSettings:null,customColorSettings:{"color":null,"backgroundColor":null},customSizeSettings:{"width":null,"maxWidth":null,"minWidth":null,"height":null,"maxHeight":null,"minHeight":null},redirectUrl:null,
        redirectTarget:{},
        tooltipText:null,
        };
  
    /* Component: Button 6 */
    button_6: any = {
      text:"Liife",type:"default",shape:"default",size:"small",colorType:"default",icon:null,iconPlacement:null,transparent:false,loading:false,block:false,disabled:null,key:"",emitWithoutPopconfirm:null,popconfirmTitle:"",borderSettings:{"border":"","borderColor":"#1f1be5","borderStyle":"solid","borderRadius":null,"borderTop":"1px","borderRight":"1px","borderBottom":"1px","borderLeft":"1px","borderTopLeftRadius":null,"borderTopRightRadius":"0px","borderBottomLeftRadius":null,"borderBottomRightRadius":"0px"},marginSettings:null,paddingSettings:{"all":"0","top":"","right":"","bottom":"","left":""},shadowSettings:null,customColorSettings:{"color":"","backgroundColor":""},customSizeSettings:{"width":"80px","maxWidth":null,"minWidth":null,"height":null,"maxHeight":null,"minHeight":null},redirectUrl:null,
        redirectTarget:{},
        tooltipText:null,
        };
  
    /* Component: Image 5 */
    image_5: any = {
      source:"https://api.rapider.ai/project-files/get-file-content/bba7d05c-2cac-43dd-8f9f-688419327bf4",alternateText:"",placeholder:null,disablePreview:false,borderSettings:null,shadowSettings:null,paddingSettings:null,marginSettings:null,customSizeSettings:{"width":"120px","maxWidth":null,"minWidth":null,"height":null,"maxHeight":null,"minHeight":null},};
  
    /* Component: Button 3 */
    button_3: any = {
      text:"Sign Out",type:"default",shape:"default",size:"small",colorType:"default",icon:{"name":"fa-solid fa-user-circle","type":"FONT_AWESOME"},iconPlacement:"right",transparent:false,loading:false,block:false,disabled:null,key:"",emitWithoutPopconfirm:null,popconfirmTitle:"",borderSettings:{"border":"","borderColor":"#1f1be5","borderStyle":"solid","borderRadius":null,"borderTop":null,"borderRight":null,"borderBottom":null,"borderLeft":null,"borderTopLeftRadius":"0px","borderTopRightRadius":null,"borderBottomLeftRadius":"0px","borderBottomRightRadius":null},marginSettings:null,paddingSettings:{"all":"0","top":"","right":"","bottom":"","left":""},shadowSettings:null,customColorSettings:{"color":"","backgroundColor":""},customSizeSettings:{"width":"80px","maxWidth":null,"minWidth":null,"height":null,"maxHeight":null,"minHeight":null},redirectUrl:null,
        redirectTarget:{},
        tooltipText:null,
        };
  
    /* Component: Button 9 */
    button_9: any = {
      text:"Liife",type:"link",shape:"default",size:"default",colorType:"default",icon:null,iconPlacement:null,transparent:false,loading:false,block:false,disabled:null,key:"",emitWithoutPopconfirm:null,popconfirmTitle:"",borderSettings:{"border":"","borderColor":null,"borderStyle":null,"borderRadius":null,"borderTop":null,"borderRight":null,"borderBottom":null,"borderLeft":null,"borderTopLeftRadius":null,"borderTopRightRadius":null,"borderBottomLeftRadius":null,"borderBottomRightRadius":null},marginSettings:null,paddingSettings:null,shadowSettings:null,customColorSettings:{"color":null,"backgroundColor":null},customSizeSettings:{"width":null,"maxWidth":null,"minWidth":null,"height":null,"maxHeight":null,"minHeight":null},redirectUrl:null,
        redirectTarget:{},
        tooltipText:null,
        };
  
    /* Component: Heading 11 */
    heading_11: any = {
      content:"Company",type:"h6",typography:{},
        colorSettings:{},
        };
  
    /* Component: Heading 29 */
    heading_29: any = {
      content:"Contact",type:"h5",typography:{},
        colorSettings:{},
        };
  
    /* Component: Text 37 */
    text_37: any = {
      textMode:"text",text:"© Copyright 2024 Liife",content:"<html>\n<head>\n<style>\n/* This style sets the width of all images to 100%: */\nimg {\n  width: 100%;\n}\n</style>\n</head>\n<body>\n<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis pulvinar lorem in facilisis viverra. Cras leo arcu, sodales nec mattis eu, tincidunt at dui. Nunc viverra luctus arcu ac tristique. Fusce nulla velit, ornare tempus efficitur vel, semper feugiat nibh.</p>\n<img src=\"/assets/img/placeholders/placeholder-primary.png\" alt=\"HTML5 Icon\" style=\"width:128px;height:128px;\">\n</body>\n</html>",typography:{"fontSize":"0auto","fontFamily":null,"fontWeight":null,"fontStyle":null,"textDecoration":"none","textAlign":null,"textShadow":null,"fontStretch":null,"textIndent":null,"letterSpacing":null,"lineHeight":null,"wordSpacing":null,"textTransform":null,"userSelect":null,"textColor":null},colorSettings:{"color":"","backgroundColor":""},};
  
    /* Component: Button 2 */
    button_2: any = {
      text:"Liife",type:"default",shape:"default",size:"small",colorType:"default",icon:null,iconPlacement:null,transparent:false,loading:false,block:false,disabled:null,key:"",emitWithoutPopconfirm:null,popconfirmTitle:"",borderSettings:{"border":"","borderColor":"#1f1be5","borderStyle":"solid","borderRadius":null,"borderTop":"1px","borderRight":"1px","borderBottom":"1px","borderLeft":"1px","borderTopLeftRadius":null,"borderTopRightRadius":"0px","borderBottomLeftRadius":null,"borderBottomRightRadius":"0px"},marginSettings:null,paddingSettings:{"all":"0","top":"","right":"","bottom":"","left":""},shadowSettings:null,customColorSettings:{"color":"","backgroundColor":""},customSizeSettings:{"width":"80px","maxWidth":null,"minWidth":null,"height":null,"maxHeight":null,"minHeight":null},redirectUrl:null,
        redirectTarget:{},
        tooltipText:null,
        };
  
    /* Component: Button 31 */
    button_31: any = {
      text:"support@liife",type:"link",shape:"default",size:"default",colorType:"default",icon:null,iconPlacement:null,transparent:false,loading:false,block:false,disabled:null,key:"",emitWithoutPopconfirm:null,popconfirmTitle:"",borderSettings:{"border":"","borderColor":null,"borderStyle":null,"borderRadius":null,"borderTop":null,"borderRight":null,"borderBottom":null,"borderLeft":null,"borderTopLeftRadius":null,"borderTopRightRadius":null,"borderBottomLeftRadius":null,"borderBottomRightRadius":null},marginSettings:null,paddingSettings:null,shadowSettings:null,customColorSettings:{"color":null,"backgroundColor":null},customSizeSettings:{"width":null,"maxWidth":null,"minWidth":null,"height":null,"maxHeight":null,"minHeight":null},redirectUrl:null,
        redirectTarget:{},
        tooltipText:null,
        };
  
    /* Component: Button 15 */
    button_15: any = {
      text:"Pricing",type:"link",shape:"default",size:"default",colorType:"default",icon:null,iconPlacement:null,transparent:false,loading:false,block:false,disabled:null,key:"",emitWithoutPopconfirm:null,popconfirmTitle:"",borderSettings:{"border":"","borderColor":null,"borderStyle":null,"borderRadius":null,"borderTop":null,"borderRight":null,"borderBottom":null,"borderLeft":null,"borderTopLeftRadius":null,"borderTopRightRadius":null,"borderBottomLeftRadius":null,"borderBottomRightRadius":null},marginSettings:null,paddingSettings:null,shadowSettings:null,customColorSettings:{"color":null,"backgroundColor":null},customSizeSettings:{"width":null,"maxWidth":null,"minWidth":null,"height":null,"maxHeight":null,"minHeight":null},redirectUrl:null,
        redirectTarget:{},
        tooltipText:null,
        };
  
    /* Component: Button 17 */
    button_17: any = {
      text:"Community",type:"link",shape:"default",size:"default",colorType:"default",icon:null,iconPlacement:null,transparent:false,loading:false,block:false,disabled:null,key:"",emitWithoutPopconfirm:null,popconfirmTitle:"",borderSettings:{"border":"","borderColor":null,"borderStyle":null,"borderRadius":null,"borderTop":null,"borderRight":null,"borderBottom":null,"borderLeft":null,"borderTopLeftRadius":null,"borderTopRightRadius":null,"borderBottomLeftRadius":null,"borderBottomRightRadius":null},marginSettings:null,paddingSettings:null,shadowSettings:null,customColorSettings:{"color":null,"backgroundColor":null},customSizeSettings:{"width":null,"maxWidth":null,"minWidth":null,"height":null,"maxHeight":null,"minHeight":null},redirectUrl:null,
        redirectTarget:{},
        tooltipText:null,
        };
  

  /* state subscriptions */
  subscriptions: Subscription[];

  /* visibility condition variables */
  

  constructor(
    private store: Store<DataStorage>
  ) {
    // prettier-ignore
    // #region customCode: page-component-ts__constructor__start
    
    // #endregion customCode: page-component-ts__constructor__start

    // prettier-ignore
    // #region customCode: page-component-ts__constructor__end
    
    // #endregion customCode: page-component-ts__constructor__end
  }

  ngOnInit(): void {
    // prettier-ignore
    // #region customCode: page-component-ts__ui-page-on-init__start
    
    // #endregion customCode: page-component-ts__ui-page-on-init__start

    this.subscribeToData();
    this.subscribeToDataSelectors();

    // prettier-ignore
    // #region customCode: page-component-ts__ui-page-on-init__end
    
    // #endregion customCode: page-component-ts__ui-page-on-init__end
  }

  ngOnDestroy(): void {
    // prettier-ignore
    // #region customCode: page-component-ts__ui-page-on-destroy__start
    
    // #endregion customCode: page-component-ts__ui-page-on-destroy__start
    
    this.subscriptions?.forEach(subscription => subscription.unsubscribe());

    // prettier-ignore
    // #region customCode: page-component-ts__ui-page-on-destroy__end
    
    // #endregion customCode: page-component-ts__ui-page-on-destroy__end
  }

  subscribeToData() {
    this.subscriptions = [
      ];
  }

  subscribeToDataSelectors() {
    const dataSelectors = [
      
    ];
    this.subscriptions.push(...dataSelectors);
  }

  
  
  
  
  
  
  
  
  
  
  
  
  
  button_6_click(output: any) {
        of(
            JSONAtaObject.chain(output)
          ).pipe(
            mergeMap(payloadAsJsonataObj => {
              /* Data Transformation Step 1 ( Map ) */
              /* get value of the passed jsonata object */
              const data = <any>payloadAsJsonataObj.value;
              /* transform data */
              const transformedData = JSONAtaObject.chain(data).transform(`
                {"path":"/"}
              `);
              return transformedData;
            }),
            tap(payloadAsJsonataObj => {
              /* get value of the passed jsonata object */
              const payload = <any>payloadAsJsonataObj.value;
              /* dispatch events */
              this.store.dispatch(Navigate({ payload }));
            }),
          ).subscribe();
        }
    
  
  button_3_click(output: any) {
        of(
            JSONAtaObject.chain(output)
          ).pipe(
            mergeMap(payloadAsJsonataObj => {
              /* Data Transformation Step 1 ( Map ) */
              /* get value of the passed jsonata object */
              const data = <any>payloadAsJsonataObj.value;
              /* transform data */
              const transformedData = JSONAtaObject.chain(data).transform(`
                
          {"path":"/auth/register"}
              `);
              return transformedData;
            }),
            tap(payloadAsJsonataObj => {
              /* get value of the passed jsonata object */
              const payload = <any>payloadAsJsonataObj.value;
              /* dispatch events */
              this.store.dispatch(Navigate({ payload }));
            }),
          ).subscribe();
        }
    
  button_9_click(output: any) {
        of(
            JSONAtaObject.chain(output)
          ).pipe(
            mergeMap(payloadAsJsonataObj => {
              /* Data Transformation Step 1 ( Map ) */
              /* get value of the passed jsonata object */
              const data = <any>payloadAsJsonataObj.value;
              /* transform data */
              const transformedData = JSONAtaObject.chain(data).transform(`
                {"path":"/"}
              `);
              return transformedData;
            }),
            tap(payloadAsJsonataObj => {
              /* get value of the passed jsonata object */
              const payload = <any>payloadAsJsonataObj.value;
              /* dispatch events */
              this.store.dispatch(Navigate({ payload }));
            }),
          ).subscribe();
        }
    
  
  
  
  button_2_click(output: any) {
        of(
            JSONAtaObject.chain(output)
          ).pipe(
            mergeMap(payloadAsJsonataObj => {
              /* Data Transformation Step 1 ( Map ) */
              /* get value of the passed jsonata object */
              const data = <any>payloadAsJsonataObj.value;
              /* transform data */
              const transformedData = JSONAtaObject.chain(data).transform(`
                {
              "path": "/"
          }
              `);
              return transformedData;
            }),
            tap(payloadAsJsonataObj => {
              /* get value of the passed jsonata object */
              const payload = <any>payloadAsJsonataObj.value;
              /* dispatch events */
              this.store.dispatch(Navigate({ payload }));
            }),
          ).subscribe();
        }
    
  
  
  
  // prettier-ignore
    // #region customCode: page-component-ts__ui-page-component-class__end
    
    // #endregion customCode: page-component-ts__ui-page-component-class__end
}
